import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private authService = inject(AuthService);
  private isRedirecting = false;

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: unknown) => {
        if (this.isUnauthorizedError(error)) {
          this.authService.logout();
          return EMPTY;
        }
        if (this.isLoginRequiredError(error)) {
          if (this.isRedirecting) {
            return EMPTY;
          }
          this.isRedirecting = true;
          this.authService.loginWithRedirect();
          return EMPTY;
        }
        return throwError(() => error);
      }),
    );
  }

  private isLoginRequiredError(error: unknown): boolean {
    return (error as { error?: string })?.error === 'login_required';
  }

  private isUnauthorizedError(errorResponse: unknown) {
    if (errorResponse instanceof HttpErrorResponse) {
      // Timeout error can arrive with an empty body, so `error` may be null.
      return errorResponse.error?.code === '18019';
    }
    return false;
  }
}
